// extracted by mini-css-extract-plugin
module.exports = {"container":"NotesCard_container__2smF4","card":"NotesCard_card__bAZTv","edit":"NotesCard_edit__v52Y4","left":"NotesCard_left__3xIQq","right":"NotesCard_right__B6wH4"};